function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        opacity: 0.503;\n      }\n\n      .cls-3 {\n        opacity: 0.506;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Marque_dot_1",
  "data-name": "Marque  dot 1",
  transform: "translate(13229 -1606)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_49",
  "data-name": "Path 49",
  className: "cls-1",
  d: "M32.449,5.629A5.629,5.629,0,1,0,38.078,0a5.629,5.629,0,0,0-5.629,5.629",
  transform: "translate(-13245.324 1606)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_50",
  "data-name": "Path 50",
  className: "cls-2",
  d: "M32.449,52.995a5.629,5.629,0,1,0,5.629-5.629,5.629,5.629,0,0,0-5.629,5.629",
  transform: "translate(-13245.324 1582.678)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_51",
  "data-name": "Path 51",
  className: "cls-3",
  d: "M0,29.346a5.629,5.629,0,1,0,5.629-5.629A5.629,5.629,0,0,0,0,29.346",
  transform: "translate(-13229 1594.322)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_76",
  "data-name": "Rectangle 76",
  className: "cls-4",
  width: 27.383,
  height: 35.301,
  transform: "translate(-13229 1606)"
}));

var SvgMarque = function SvgMarque(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.383,
    height: 35.301,
    viewBox: "0 0 27.383 35.301",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarque, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Marque.b3ffff7e.svg";
export { ForwardRef as ReactComponent };